/**
 * Direct re-exports from `react-router`. Import this instead of
 * `react-router` when a module must not go through `legacyReactRouter.ts`
 * (Jest maps `react-router` there, which re-exports `Prompt` and would create a
 * circular dependency with `react-router-dom`).
 */
// Bypass Jest mapping by using direct node_modules path
// Note: We must explicitly import and re-export the renamed context exports
// because `export *` doesn't preserve the `as` aliases from the source module
// This file exists to provide stable context references across Jest ESM/CJS interop

import * as rr from '../node_modules/react-router'

// Re-export everything
export * from '../node_modules/react-router'

// Explicitly re-export renamed exports (UNSAFE_ prefix is React Router's internal naming)
/* eslint-disable camelcase, prefer-destructuring */
export const UNSAFE_DataRouterContext = rr.UNSAFE_DataRouterContext
export const useBlocker = rr.useBlocker
